import React, { useEffect, useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminHeader from '@Components/common/AdminHeader';
import Portal from '@Components/common/Layouts/Portal';
import hasErrorBoundary from '@Components/common/hasErrorBoundary';
import SubSectorTable from './SubSectorTable';
import SubSectorForm from './SubSectorForm';

const SubSector = () => {
  const navigate = useNavigate();
  const [toggleForm, setToggleForm] = useState<boolean>(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.includes('edit') || pathname.includes('add')) {
      setToggleForm(true);
    } else {
      setToggleForm(false);
    }
  }, [pathname]);
  const springs = useSpring({
    from: { y: 100 },
    to: { y: 0 },
  });

  return (
    <animated.div
      style={{ ...springs }}
      className="naxatw-flex naxatw-h-full naxatw-flex-col naxatw-space-y-6"
    >
      <AdminHeader
        title="Sub Sectors"
        onAddNewClick={() => {
          navigate('/data-bank/sectors/sub-sector/add');
        }}
      />
      <SubSectorTable />
      {toggleForm && (
        <Portal>
          <SubSectorForm
            onClose={() => {
              navigate('/data-bank/sectors/sub-sector');
            }}
          />
        </Portal>
      )}
    </animated.div>
  );
};

export default hasErrorBoundary(SubSector);
